import React from 'react';

import Tooltip from '~/components/core/Atomic/Tooltip';
import StatusChipCore from '~/components/core/StatusChipCore';
import OverflowTextWithToolTip from '~/components/OverflowTextWithToolTip';
import type { ContactFullModel } from '~/server_shared/swagger/data-contracts';
import cn from '~/Utils/cn';

interface IdentityHeaderPropsType {
  contact: ContactFullModel;
}

const IdentityHeader: React.FC<IdentityHeaderPropsType> = ({ contact }) => {
  return (
    <div className="flex items-center gap-8">
      <OverflowTextWithToolTip textWrapperClassName={cn(contact.is_deceased && 'text-slate-700')} maxWidth="400px">
        {[contact.title, contact.full_name].filter(Boolean).join(' ')}
        {contact.is_deceased ? ' (deceased)' : ''}
      </OverflowTextWithToolTip>
      {contact.is_deactivated && (
        <Tooltip
          title={
            <div>
              <div>{contact.deactivation_reason}</div>
            </div>
          }
          arrow
          placement="top"
        >
          <div>
            <StatusChipCore status="INACTIVE" color="grey" />
          </div>
        </Tooltip>
      )}
    </div>
  );
};

export default IdentityHeader;
